import { Vue } from 'ui.vue';
Vue.component('vue-product-bonus-checkbox', {
    data() { return {} },
    props: {
        productId: Number,
        showBonusIcon: {
            type: Boolean,
            default: false
        },
        showBonusHelpIcon: {
            type: Boolean,
            default: true
        },
    },
    computed: {
        localize() {
            return Vue.getFilteredPhrases("VUE_BONUS_");
        },
        basketProduct: (state) => {
            return state.$store.hasModule("basket") ? state.$store.getters['basket/findItem'](state.$props.productId) : null;
        },
        basketSaleType: (state) => {
            return state.$store.getters['bonus/getSaleType'];
        },
        catalogProduct: (state) => {
            return state.$store.hasModule("catalog") ? state.$store.getters['catalog/findItem'](state.$props.productId) : null;
        },
        bonusList: (state) => {
            return state.$store.getters['bonus/getBonusList'];
        },
        bonusTotalSum: (state) => {
            return state.$store.getters['bonus/getBonusTotalSum'];
        },
        catalogProductCanBuyForBonuses: (state) => {
            return state.checkByProductByBonus()
                && (state.userBonusPossibilityForProductBuy || state.cartProductBuyForBonuses);
        },
        cartProductBuyForBonuses: {
            get() {
                return this.basketProduct?.PROPS?.BONUS_EXCHANGE?.VALUE == 'Y';
            },
            set(isChecked) {
                if (isChecked && this.userBonusPossibilityForProductBuy || this.cartProductBuyForBonuses) {
                    this.toggleProductProps();
                } else if (!isChecked) {
                    this.toggleProductProps();
                } else {
                    alert(this.localize.VUE_BONUS_NOT_ENOTH);
                }
            }
        },
        userBonusPossibilityForProductBuy: (state) => {
            return state.$store.getters['bonus/getUserBonusPossibilityForProductBuy'](state.basketSaleType, state.basketProduct);
        },
        showCheckbox: (state) => {
            return state.basketSaleType == "ORDER_BUY_PRODUCT_BONUS" && state.$store.getters['bonus/getUserBonusPossibilityForProduct'](state.basketSaleType, state.basketProduct);
        },
        canUserCheckCheckbox: (state) => {
            return (state.catalogProductCanBuyForBonuses || state.cartProductBuyForBonuses) && !state.isLoading;
        },
        checkboxTitle: (state) => {
            return state.cartProductBuyForBonuses ? state.localize?.VUE_BONUS_USED_BONUS : (state.canUserCheckCheckbox ? state.localize?.VUE_BONUS_USE_BONUS : state.localize?.VUE_BONUS_USE_NOT_ENOUGH);
        },
        isLoading: (state) => {
            return state.$store.getters['isLoading'];
        }
    },
    methods: {
        toggleProductProps: function () {
            if (typeof this.basketProduct?.PROPS == 'undefined') this.basketProduct.PROPS = {};
            let product = this.basketProduct;
            if (!this.cartProductBuyForBonuses && product) {
                let event = { product: product, result: true };
                BX.onCustomEvent("OnBeforeProductBonusBuyOn", event);
                if (event.result) {
                    return this.$store.dispatch('basket/setProductProperty', {
                        ID: product.ID,
                        PROPS: {
                            BONUS_EXCHANGE: {
                                NAME: 'BONUS_EXCHANGE',
                                CODE: 'BONUS_EXCHANGE',
                                VALUE: 'Y'
                            }
                        }
                    }).then(response => {
                        BX.onCustomEvent("OnAfterProductBonusBuyOn", product);
                    });
                }
            } else if (product) {
                let event = { product: product, result: true };
                BX.onCustomEvent("OnBeforeProductBonusBuyOff", event);
                if (event.result) {
                    return this.$store.dispatch('basket/setProductProperty', {
                        ID: product.ID,
                        PROPS: {
                            BONUS_EXCHANGE: {
                                CODE: 'BONUS_EXCHANGE',
                                VALUE: false
                            }
                        }
                    }).then(response => {
                        BX.onCustomEvent("OnAfterProductBonusBuyOff", product);
                    });
                }
            }
        },
        checkByProductByBonus: function () {
            if (this.cartProductBuyForBonuses
                && this.catalogProduct?.PRICE > 0
                && this.REAL_PRODUCT_PRICE == null
            ) {
                this.REAL_PRODUCT_PRICE = this.catalogProduct.PRICE;
                this.$store.commit('catalog/updateItem', {
                    ID: this.catalogProduct.ID,
                    PRICE: 0,
                    DISCOUNT_PRICE: this.catalogProduct.PRICE,
                });
            }
            if (!this.cartProductBuyForBonuses
                && this.catalogProduct?.PRICE == 0
                && this.REAL_PRODUCT_PRICE > 0
            ) {
                this.$store.commit('catalog/updateItem', {
                    ID: this.catalogProduct.ID,
                    PRICE: this.REAL_PRODUCT_PRICE,
                    DISCOUNT_PRICE: 0,
                });
                this.REAL_PRODUCT_PRICE = null;
            }
            return true
        }
    },
    mounted() { },
    template: `
        <span v-if="basketProduct && showCheckbox" class="bonus-checkbox-wrap">
            <i v-if="showBonusIcon" :class="['fas fa-coins', {'text-dark': !cartProductBuyForBonuses},{'text-success': cartProductBuyForBonuses}]"></i>
            <input type="checkbox" class="bonus-checkbox"
                v-model="cartProductBuyForBonuses"
                :disabled="!canUserCheckCheckbox"
                :title="checkboxTitle"
                >
            <i v-if="showBonusHelpIcon && !canUserCheckCheckbox && !isLoading" :title="checkboxTitle" class="small far fa-question-circle"></i>
        </span>`
});
